import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const NoContentLabel = () => /*#__PURE__*/_jsx("i", {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-message-history.noContent"
  })
});
NoContentLabel.displayName = 'NoContentLabel';
export default NoContentLabel;